<picture class="{{ imageType() }}" [style]="blurStyle()">
  @for (srcset of srcsetArr(); track $index) {
    <source [media]="srcset[0]" [srcset]="srcset[1]" />
  }
  @if (generalService.isBrowserOnly) {
    @if (shouldRender()) {
      <img [alt]="name()" [src]="src()" [class]="{ loaded: imageLoaded() }" (load)="handleImageLoad()" />
    }
  } @else {
    <img [alt]="name()" [src]="src()" [class]="{ loaded: imageLoaded() }" (load)="handleImageLoad()" />
  }
</picture>
